<template>
  <div v-if="stock !== null" class="cmp-product-stock utlz-reset">
    <!-- BESPOKE BAAK: Disable stock if product is out of stock -->
    <template v-if="stock.stockTotal > 0">
      <div class="stock-wrapper">
        <template v-if="stock !== null">
          <template v-if="stockType === 1">
            <span class="stock-label" v-translation="{type: 'label', code: 'label_stock_indicator'}">:</span>
            <span class="stock-count">{{ stockTotal }}</span>
          </template>
          <template v-else-if="stockType === 4">
            <div class="stock-indicators">
              <img :src="'/' + stockIndicator.image" />
              <span>{{ stockIndicator.description }}</span>
            </div>
          </template>
        </template>
        <div v-else-if="showStock" class="stock-status-wrapper text-placeholder pulse">
          <span class="loader"></span>
          <span v-translation="{ type: 'label', code: 'label_retrieving_stock' }"></span>
        </div>
      </div>
    </template>
    <!-- END BESPOKE BAAK -->
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  props: {
    stock: { type: Object, required: false }
  },
  computed: {
    ...mapGetters(['showStock', 'stockIndicators', 'stockType']),
    stockTotal () {
      return this.stock.stockTotal < 0 ? 0 : this.stock.stockTotal;
    },
    stockIndicator () {
      
      let stockLimit = this.stock.stockLimit;
      let stockTotal = this.stock.stockTotal;

      // BESPOKE BAAKB-59
      // If a stock limit is active, we ignore the default logic for the indicators
      // and instead follow the logic of uc_product_stock:
      // Als de module stock limit aan staat en bij een product is een limiet vastgelegd (hoger dan 0)
      // limiet is het ideale voorraad aantal van een product.
      // De standaard indicatoren obv voorraad aantal worden overschreven.
      // Als voorraad klein of gelijk aan 0 toon dan de laagste (stock_quantity asc)
      // Als limiet kleiner of gelijk aan voorraad toon dan de hoogste (stock_quantity desc)
      // Als limiet hoger dan voorraad toon de 1-na-hoogste indicator
      if (this.stock.useStockLimit) {

        if (stockTotal <= 0) {
            let indicatorsAscOrder = this.stockIndicators.sort((x, y) => x.quantity - y.quantity);            
            return indicatorsAscOrder[0];
        } else if (stockLimit <= stockTotal) {
          let indicatorsDescOrder = this.stockIndicators.sort((x, y) => y.quantity - x.quantity);
          return indicatorsDescOrder[0];
        } else if (stockLimit > stockTotal) {
          let indicatorsDescOrder = this.stockIndicators.sort((x, y) => y.quantity - x.quantity);
          let index = indicatorsDescOrder.length > 1 ? 1 : 0;
          return this.stockIndicators[index];
        }
      } else {
        // BESPOKE BAAK
        // THe same logic as uc_product_stock.ascx.vb line 116, where a product has no stock limit
        // Dim qsc_data_table As New Utilize.Data.QuerySelectClass
        // qsc_data_table.select_fields = "top 1 *"
        // qsc_data_table.select_from = "uws_stock_indicators"
        // qsc_data_table.select_where = "stock_quantity >= @stock_quantity"
        // qsc_data_table.add_parameter("stock_quantity", ln_stock)
        // qsc_data_table.select_order = "stock_quantity asc"
        var indicator = this.stockIndicators
        .filter(item => item.quantity >= stockTotal)
        .sort((a, b) => a.quantity - b.quantity)[0];
        return indicator;
      }
      // END BESPOKE BAAKB-59
    }
  }
}
</script>

<style>
</style>
